module.exports = "data:image/png;base64,UklGRm4BAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSJcAAAABn6GwbSM19YWjp4iIld4i5fBjb/SDNnIEJ/bHjmPNJsUEFLQAh5Fkm9Y+2/5+Nv6/+Ud37z8xRPR/AkBUvaI2QHV2xmjKwJhOkRtWvQwK6icgAUjHceZbC3zI/s+CD4EJEsJuujaA+/W91nVd+yzPQwBQ/IivMhsy55f847f5sUTJ379zEkATJhdbFIE46I7dJilReTMBAFZQOCCwAAAAMAIAnQEqEAAQAAIANCWwAnQGLLbUnx7tFSAA/tjtwHyB887MrPJu6hUc3H/sWptKqi1pknT5XU+IYD+K+T/z1fFdj69LU4o8GWDxlZEiVRe5HY+EwjA/Vt+4siP9DC+1nb1/kdM6Lv0pMspnIF6RRHSIi/gpzVXzM3b6hxW6fRHwfvjYw/tsP/tBvc51IqevrlcKpgsrLvdtNImcyCGlluxRdfF2I8WP12gY3Z1yzAA="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes_icons/icon_Blueprint_BreakStruct_16x.png
// module id = 38
// module chunks = 0